import { isEmptyObject } from "../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values, t) => 
{
    let formErrors = {};
 
    let name = values["Name"];

    if (!name || name.trim().length == 0)
        formErrors = Object.assign(formErrors, {Name: t("migrations.name1")});

        //console.log(formErrors)
    if (isEmptyObject(formErrors))
       return undefined;

    return formErrors;        
}